import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ContentHeader, ContentNav } from 'src/components'

class CostsNavigation extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    }

    static NAV_ITEMS = [
        {
            name: 'Overview',
            link: 'costs-overview',
        },
    ]

    render() {
        const { title } = this.props

        return (
            <ContentHeader>
                <ContentNav
                    title={title}
                    contentNavItems={CostsNavigation.NAV_ITEMS}
                >
                    {this.props.children}
                </ContentNav>
            </ContentHeader>
        )
    }
}

export default CostsNavigation
